var map = {
	"./fomede_LIBER_Data-Set-15.png": "36ea",
	"./fomede_LIBER_Data-Set-6.png": "c941",
	"./fomede_LIBER_açaí.png": "fecf",
	"./fomede_LIBER_burger.png": "c373",
	"./fomede_LIBER_comida-fit.png": "576b",
	"./fomede_LIBER_cupcake.png": "cf74",
	"./fomede_LIBER_dadinho.png": "e8dc",
	"./fomede_LIBER_esfiha.png": "97fc",
	"./fomede_LIBER_feijoada.png": "dd22",
	"./fomede_LIBER_frango-frito.png": "ec39",
	"./fomede_LIBER_hambúrguer.png": "29b4",
	"./fomede_LIBER_japa.png": "71dc",
	"./fomede_LIBER_lanche.png": "3329",
	"./fomede_LIBER_macarrão.png": "cf87",
	"./fomede_LIBER_marmita.png": "21e5",
	"./fomede_LIBER_panqueca.png": "d340",
	"./fomede_LIBER_pastel.png": "7ed5",
	"./fomede_LIBER_pão.png": "c78f",
	"./fomede_LIBER_risoto.png": "09f0",
	"./fomede_LIBER_salada.png": "586b",
	"./fomede_LIBER_salgadinho.png": "4d70",
	"./fomede_LIBER_sanduba.png": "4d709",
	"./fomede_LIBER_sonho.png": "d195",
	"./fomede_LIBER_sorvete.png": "533e",
	"./fomede_LIBER_yakisoba.png": "1056",
	"./março-on-fire-restaurantes-feed.png": "4b7c",
	"./março-on-fire-restaurantes-story.png": "4830",
	"./modelo_feed_com_logo.png": "e649",
	"./modelo_stories_com_logo.png": "9a7b",
	"./vemproapp_generica_restaurante_feed.png": "20fb",
	"./vemproapp_generica_restaurante_story.png": "c91f",
	"./vestamosnoaiq_desconto_black-feed.png": "772c",
	"./vestamosnoaiq_desconto_black-story.png": "540f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8151";